// app/frontend/router/routes.js
export default [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../pages/Dashboard.vue'),
    meta: { requiresAuth: true, requiresApproval: true }
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('../pages/Account.vue'),
    meta: { requiresAuth: true, requiresApproval: true }
  },
  {
    path: '/users/:id',
    name: 'UserProfile',
    component: () => import('../pages/UserProfile.vue'),
    meta: { requiresAuth: true, requiresApproval: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../pages/Reports.vue'),
    meta: { requiresAuth: true, requiresApproval: true }
  },
  {
    path: '/updates',
    name: 'Updates',
    component: () => import('../pages/Updates.vue'),
    meta: { requiresAuth: true, requiresApproval: true }
  },
  {
    path: '/pending-approval',
    name: 'PendingApproval',
    component: () => import('../pages/PendingApproval.vue'),
    meta: { requiresAuth: true, requiresApproval: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../pages/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('../pages/Signup.vue'),
    meta: { guest: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../pages/NotFound.vue'),
  },
]